import mutations from './eprofileImplantatum.mutations'
import actions from './eprofileImplantatum.actions'
import getters from './eprofileImplantatum.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
